import * as types from "./types";

const mutations = {
    [types.LOADING_EVENT](state, value) {
        state.loading = value;
    },
    [types.GET_EVENT_LIST](state, event) {
        state.event = event;
    },
    [types.REMOVE_EVENT](state, id) {        
        state.event = state.event.filter((x) => x.id !== id);        
    },
    [types.ADD_EVENT](state, event) {        
        state.event.unshift(event);
    },
    [types.UPDATE_EVENT](state, event) {        
        const eventIndex = state.event.findIndex((x) => x.id === event.id);
        state.event[eventIndex] = event;        
    },
    [types.GET_EVENT_BYID](state, id) {        
        state.event = state.event.filter((x) => x.id !== id);        
    },
};

export default mutations;